<script>
  import { Tag } from 'element-ui'
  export default {
    name:'ElTag',
    extends:Tag
  }
</script>
